import { render, staticRenderFns } from "./costStatement.vue?vue&type=template&id=df4207d4&scoped=true&"
import script from "./costStatement.vue?vue&type=script&lang=ts&"
export * from "./costStatement.vue?vue&type=script&lang=ts&"
import style0 from "./costStatement.vue?vue&type=style&index=0&id=df4207d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4207d4",
  null
  
)

export default component.exports